<template>
  <div>
    <section class="logo-ctn" :class="{'logo-ctn--centered' : hasLogoAnimationEnded}">
      <div id="logo-bg" ref="bg" class="logo-bg" :class="{'logo-bg--static' : hasLogoAnimationEnded}" />
      <div class="dnare-d-ctn">
        <img id="dnare-d"
             ref="dnare-d"
             class="dnare-d"
             src="@/assets/dnare/d.svg"
             alt=""
        >
      </div>
      <div ref="logo-wrapper" :class="{'logo-wrapper' : hasLogoAnimationEnded}">
        <div class="logo-feature logo-feature--bg" :class="{'logo-feature--visible' : selectedFeature === 'bg'}">
          <h4>Cores</h4>
          <p>Gradiente do #ECB347 ao #EA8E43</p>
          <p>Sol. Feminino.</p>
          <p>Cor quente. Calorosidade.</p>
        </div>
        <div class="logo-feature logo-feature--d-top" :class="{'logo-feature--visible' : selectedFeature === 'd-top'}">
          <h4>Símbolo após o D</h4>
          <p>O D com asterisco simboliza toda a marca.</p>
          <p>Algo mais a contar.</p>
          <p>D*</p>
        </div>
        <div class="logo-feature logo-feature--d-bottom" :class="{'logo-feature--visible' : selectedFeature === 'd-bottom'}">
          <h4>D como única letra maiúscula</h4>
          <p>Distinção e força ao substantivo próprio.</p>
        </div>
        <div class="logo-feature logo-feature--n" :class="{'logo-feature--visible' : selectedFeature === 'n'}">
          <h4>Panton ExtraBold</h4>
          <p>Terminações arredondadas e traços retos.</p>
          <p>Aspecto suave à marca.</p>
        </div>
        <btn
          class="feature-dot feature-dot--d-bottom"
          :class="{'feature-dot--selected' : selectedFeature === 'd-bottom', 'feature-dot--transitionable' : hasDotsAnimationEnded}"
          @click="toggleFeature"
        >
          <span data-feature="d-bottom" />
        </btn>
        <btn
          class="feature-dot feature-dot--d-top"
          :class="{'feature-dot--selected' : selectedFeature === 'd-top', 'feature-dot--transitionable' : hasDotsAnimationEnded}"
          @click="toggleFeature"
        >
          <span data-feature="d-top" />
        </btn>
        <btn
          class="feature-dot feature-dot--n"
          :class="{'feature-dot--selected' : selectedFeature === 'n', 'feature-dot--transitionable' : hasDotsAnimationEnded}"
          @click="toggleFeature"
        >
          <span data-feature="n" />
        </btn>
        <btn
          class="feature-dot feature-dot--bg"
          :class="{'feature-dot--selected' : selectedFeature === 'bg', 'feature-dot--transitionable' : hasDotsAnimationEnded}"
          @click="toggleFeature"
        >
          <span data-feature="bg" />
        </btn>
        <img id="dnare"
             ref="dnare"
             class="dnare-logo"
             :class="{'dnare-logo--static' : hasLogoAnimationEnded}"
             src="@/assets/dnare/dnare.svg"
             alt=""
        >
      </div>
      <btn class="dnare-btn dnare-btn--back" @click="$router.push({ name: 'portfolio' })">
        <span class="dnare-btn__icon">
          <i class="fas fa-arrow-left" />
        </span>
        <span class="dnare-btn__label">
          Voltar ao Portfólio
        </span>
      </btn>
      <btn class="dnare-btn dnare-btn--about" @click="scrollToAboutSection">
        <span class="dnare-btn__label dnare-btn__label--margin-right">
          Sobre
        </span>
        <span class="dnare-btn__icon">
          <i class="fas fa-arrow-down" />
        </span>
      </btn>
    </section>
    <section class="border">
      <div class="container about-scn mx-auto">
        <h3 class="mb-2">
          Sobre o logotipo
        </h3>
        <p>
          A Dnare é um empresa que busca criar singularidade no dia a dia através de produtos de decorações únicos e com
          grande representatividade na vida das pessoas. A ideia principal acerca da marca é provocar sentimentos e
          lembranças toda vez que um produto Dnare for visto, seja em um simples gole de café ou até mesmo a chegada ao
          lar.
        </p>
      </div>
    </section>
  </div>
</template>

<script>
import { gsap, Power3 } from 'gsap'
import { CustomEase } from 'gsap/CustomEase'
import { mapState } from 'vuex'

export default {
  name: 'Dnare',
  data () {
    return {
      selectedFeature: undefined,
      logoTl: undefined,
      hasDotsAnimationEnded: false,
      hasLogoAnimationEnded: false
    }
  },
  computed: {
    ...mapState(['vHeight', 'vWidth'])
  },
  methods: {
    removeAnimationResiduous () {
      const dnareLogo = this.$refs['dnare']
      dnareLogo.removeAttribute('style')
      this.hasLogoAnimationEnded = true
    },
    toggleFeature (e) {
      let selectedFeature = e.target.childNodes[0].getAttribute('data-feature')
      if (!selectedFeature) {
        selectedFeature = e.target.childNodes[0].childNodes[0].getAttribute('data-feature')
      }
      if (this.selectedFeature && this.selectedFeature === selectedFeature) this.selectedFeature = undefined
      else this.selectedFeature = selectedFeature
    },
    scrollToAboutSection () {
      gsap.to(window, { scrollTo: { y: '.about-scn', autoKill: false }, duration: 0.5 })
    }
  },
  created () {
    this.$store.dispatch(this.$CHANGE_CURSOR_STATE, 'default')
  },
  mounted () {
    const bg = this.$refs['bg']
    const dnareD = this.$refs['dnare-d']
    const dnareLogo = this.$refs['dnare']
    const dBoundingRect = this.$refs['dnare-d'].getBoundingClientRect()
    const dnareBoundingRect = this.$refs['dnare'].getBoundingClientRect()
    const bgCircularDiameter = Math.sqrt(Math.pow(this.vHeight, 2) + Math.pow(this.vWidth, 2))
    const bgInitialHeight = bg.getBoundingClientRect().height
    let dTop = parseInt(dBoundingRect.top)
    let dHeight = parseInt(dBoundingRect.height)
    let dnareHeight = parseInt(dnareBoundingRect.height)
    let dLeft
    dnareLogo.style.top = dTop + dHeight - dnareHeight + 'px'
    const ease = CustomEase.create('custom', 'M0,0 C0,0.88 0.344,1 1,1')
    const time = 0.8
    const scale = parseFloat((bgCircularDiameter / bgInitialHeight).toFixed(3)) + 0.5

    this.logoTl = gsap.timeline({ paused: true })
      .from(bg, time, { scale: 0, ease }, 'reveal')
      .from(dnareD, time, { scale: 2, ease }, 'reveal')
      .to(bg, time, { scale, ease }, 'scaleBg')
      .from('.feature-dot', time / 2,
        {
          scale: 0,
          ease: CustomEase.create('custom', 'M0,0 C-0.024,0.828 0.504,1 1,1'),
          stagger: 0.1
        }, 'scaleBg+=0.4')
    this.logoTl.add(() => {
      dLeft = parseInt(dnareD.getBoundingClientRect().left)
      dnareLogo.style.left = dLeft + 'px'
      dnareD.style.opacity = 0
      dnareLogo.style.opacity = 1
      const dnareLeft = parseInt(dnareLogo.getBoundingClientRect().left)
      const dnareWidth = parseInt(dnareLogo.getBoundingClientRect().width)
      const translate = parseInt((this.$store.state.vWidth / 2) - dnareLeft - (dnareWidth / 2))
      // const offset = this.vWidth <= 576 ? 2 : this.vWidth <= 992 ? 3 : this.vWidth <= 1200 ? 1 : 3
      gsap.to(dnareLogo, { x: `${translate}px`, duration: time / 2, ease, onComplete: this.removeAnimationResiduous })
    }, 'scaleBg')
    this.logoTl.add(() => {
      this.hasDotsAnimationEnded = true
      gsap.to('.dnare-btn', { y: '-100%', opacity: 1, duration: time / 2, ease: Power3.easeOut, stagger: 0.2 })
    })
    this.$root.$on('transition-dismiss', () => { this.logoTl.play() })
  }
}
</script>

<style scoped lang="sass">
@import '../assets/styles/dnare'
</style>
